// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalogue-share-link-modal {
  /* border: 1px solid red; */
  position: absolute;
  top: 60%;
  right: 1%;
  transform: translate(0%, -50%);
  width: 430px;
  height: 78%;
  background-color: white;
  color: black;
  box-shadow: 24px;
  padding: 10px;
  border-radius: 5px;
  overflow-y: auto;
}

.catalogue-share-link-modal-heading {
  color: #000000 !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  font-size: 24px !important;
  line-height: 22px !important;
  margin-bottom: 5px !important;
}
.catalogue-share-link-modal-hours {
  color: #000000 !important;
  font-family: "Karla" !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 22px !important;
  letter-spacing: -0.41px !important;
}

/* Mobile Number  */
/* 'react-phone-input-2'; */
.mobileRef .react-tel-input {
  border-radius: 5px;
  /* border: 1px solid black; */
  height: 50px !important;
  display: flex;
  align-items: center;
}

.mobileRef .react-tel-input .form-control {
  font-size: 16px !important;
  padding: 10px;
  width: 100% !important;
  font-family: "Poppins" !important;
  font-size: 18px !important;
  line-height: 27px !important;
  font-weight: 400;
  height: 27px !important;
  border: none !important;
  color: black !important;
  padding-top: 20px !important;
  padding-left: 50px !important;
}

.react-tel-input .selected-flag {
  margin-right: 5px; /* Adjust margin as needed */
}

.react-tel-input .selected-flag .arrow {
  font-weight: bold !important;
  left: 23px !important;
}

.react-tel-input .flag-dropdown {
  border: none !important;
  background-color: #fff !important;
  border-right: 1px solid #000000 !important;
  top: 25% !important;
  bottom: 25% !important;
}

.react-tel-input .flag-dropdown .country-list {
  max-height: 200px;
  overflow-y: auto;
}

.flag-dropdown .country-list .country {
  padding: 5px;
  cursor: pointer;
}

.flag-dropdown .country-list .country:hover {
  background-color: #eee;
}
`, "",{"version":3,"sources":["webpack://./src/features/catalogue/styles/sharelinkmodal.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB,EAAE,4BAA4B;AACjD;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".catalogue-share-link-modal {\n  /* border: 1px solid red; */\n  position: absolute;\n  top: 60%;\n  right: 1%;\n  transform: translate(0%, -50%);\n  width: 430px;\n  height: 78%;\n  background-color: white;\n  color: black;\n  box-shadow: 24px;\n  padding: 10px;\n  border-radius: 5px;\n  overflow-y: auto;\n}\n\n.catalogue-share-link-modal-heading {\n  color: #000000 !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  font-size: 24px !important;\n  line-height: 22px !important;\n  margin-bottom: 5px !important;\n}\n.catalogue-share-link-modal-hours {\n  color: #000000 !important;\n  font-family: \"Karla\" !important;\n  font-weight: 400 !important;\n  font-size: 12px !important;\n  line-height: 22px !important;\n  letter-spacing: -0.41px !important;\n}\n\n/* Mobile Number  */\n/* 'react-phone-input-2'; */\n.mobileRef .react-tel-input {\n  border-radius: 5px;\n  /* border: 1px solid black; */\n  height: 50px !important;\n  display: flex;\n  align-items: center;\n}\n\n.mobileRef .react-tel-input .form-control {\n  font-size: 16px !important;\n  padding: 10px;\n  width: 100% !important;\n  font-family: \"Poppins\" !important;\n  font-size: 18px !important;\n  line-height: 27px !important;\n  font-weight: 400;\n  height: 27px !important;\n  border: none !important;\n  color: black !important;\n  padding-top: 20px !important;\n  padding-left: 50px !important;\n}\n\n.react-tel-input .selected-flag {\n  margin-right: 5px; /* Adjust margin as needed */\n}\n\n.react-tel-input .selected-flag .arrow {\n  font-weight: bold !important;\n  left: 23px !important;\n}\n\n.react-tel-input .flag-dropdown {\n  border: none !important;\n  background-color: #fff !important;\n  border-right: 1px solid #000000 !important;\n  top: 25% !important;\n  bottom: 25% !important;\n}\n\n.react-tel-input .flag-dropdown .country-list {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.flag-dropdown .country-list .country {\n  padding: 5px;\n  cursor: pointer;\n}\n\n.flag-dropdown .country-list .country:hover {\n  background-color: #eee;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
